import { SlideOut } from '@interstate/components/SlideOut';
import { Box } from '@interstate/components/Box';
import { useDispatch, useSelector } from 'react-redux';
import * as creditDecisionActionCreators from '@makemydeal/dr-dash-store/actions/creditDecisionActionCreators';
import * as deskingGlobalSelectors from '@makemydeal/dr-dash-store/selectors/deskingGlobalSelectors';
import CreditDecisionActivity from './CreditDecisionActivity';
import { ActivityRouteContainer } from './CreditDecisionActivity.style';

export const CreditDecisionSlideOut = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(deskingGlobalSelectors.isCreditDecisionSlideOutOpen);

    const handleClose = () => {
        dispatch(creditDecisionActionCreators.closeCreditDecisionSlideOut());
    };

    return (
        <SlideOut
            show={isOpen}
            onHide={handleClose}
            position="right"
            panelWidth="100vw"
            data-testid="slideout-credit-decision"
            sx={{
                '& .ids-SlideOut-content': {
                    height: '100%'
                }
            }}
        >
            <Box height="100%" display="flex" flexDirection="column" position="relative" overflow="auto">
                <ActivityRouteContainer>
                    <CreditDecisionActivity />
                </ActivityRouteContainer>
            </Box>
        </SlideOut>
    );
};
